var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { ChevronLeft, ChevronRight, Download, Search } from 'lucide-react';
import services from 'services';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { downloadCsv, todayStamp } from 'pages/inventory/csv';
var PAGE_SIZE = 10;
var initialsFromName = function (name) {
    var parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return '';
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return "".concat(parts[0][0]).concat(parts[parts.length - 1][0]).toUpperCase();
};
var Users = function (_a) {
    var t = _a.translate;
    var _b = services.userService.useUsers(), users = _b.data, isLoading = _b.isLoading;
    var _c = useState(''), query = _c[0], setQuery = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var rows = users || [];
    var filtered = useMemo(function () {
        var needle = query.trim().toLowerCase();
        if (!needle)
            return rows;
        return rows.filter(function (user) {
            var haystack = [
                String(user.getId()),
                user.getName(),
                user.getEmail(),
                user.getMobile(),
                user.getTitle()
            ].join(' ').toLowerCase();
            return haystack.includes(needle);
        });
    }, [rows, query]);
    var pageCount = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    var currentPage = Math.min(page, pageCount);
    var start = (currentPage - 1) * PAGE_SIZE;
    var visible = filtered.slice(start, start + PAGE_SIZE);
    var from = filtered.length === 0 ? 0 : start + 1;
    var to = start + visible.length;
    var pageStart = Math.max(1, Math.min(currentPage - 2, pageCount - 4));
    var pageEnd = Math.min(pageCount, pageStart + 4);
    var pageNumbers = [];
    for (var number = pageStart; number <= pageEnd; number += 1)
        pageNumbers.push(number);
    var exportCsv = function () {
        downloadCsv("users-".concat(todayStamp(), ".csv"), __spreadArray([
            [t('users.id'), t('users.name'), t('users.email'), t('users.mobile'), t('users.title')]
        ], filtered.map(function (user) { return [
            String(user.getId()),
            user.getName() || '',
            user.getEmail() || '',
            user.getMobile() || '',
            user.getTitle() || ''
        ]; }), true));
    };
    return (_jsxs("div", { className: "usr", children: [_jsx("div", { className: "usr-head", children: _jsxs("div", { children: [_jsxs("div", { className: "usr-crumb", children: [_jsx("span", { children: t('header.title') }), _jsx("span", { children: "/" }), _jsx("span", { className: "usr-crumb__current", children: t('sections.users.title') })] }), _jsxs("div", { className: "usr-title", children: [_jsx("h1", { children: t('sections.users.title') }), _jsx("span", { children: t('users.count', { count: rows.length }) })] })] }) }), _jsxs("div", { className: "usr-toolbar", children: [_jsxs("label", { className: "usr-search", children: [_jsx(Search, { size: 16 }), _jsx("input", { value: query, placeholder: t('users.search'), onChange: function (event) {
                                    setQuery(event.target.value);
                                    setPage(1);
                                } })] }), _jsxs("button", { type: "button", className: "usr-export", onClick: exportCsv, children: [_jsx(Download, { size: 16 }), t('users.export')] })] }), _jsx("section", { className: "set-card", children: _jsx("div", { className: "set-table-wrap", children: _jsxs("table", { className: "set-table usr-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: t('users.id') }), _jsx("th", { children: t('users.name') }), _jsx("th", { children: t('users.email') }), _jsx("th", { children: t('users.mobile') })] }) }), _jsx("tbody", { children: visible.length === 0 ? (_jsx("tr", { children: _jsx("td", { colSpan: 4, className: "set-empty", children: isLoading ? '' : t('users.empty') }) })) : (visible.map(function (user) { return (_jsxs("tr", { children: [_jsx("td", { className: "usr-id", children: user.getId() }), _jsx("td", { children: _jsxs("div", { className: "usr-person", children: [_jsx("span", { className: "usr-avatar", "aria-hidden": true, children: initialsFromName(user.getName() || '') }), _jsxs("span", { children: [_jsx("strong", { children: user.getName() || '—' }), user.getTitle() ? _jsx("em", { children: user.getTitle() }) : null] })] }) }), _jsx("td", { children: user.getEmail() || '—' }), _jsx("td", { children: user.getMobile() || '—' })] }, user.getId())); })) })] }) }) }), _jsxs("div", { className: "usr-pager", children: [_jsx("span", { children: t('users.showing', { from: from, to: to, total: filtered.length }) }), _jsxs("div", { children: [_jsx("button", { type: "button", disabled: currentPage <= 1, onClick: function () { return setPage(currentPage - 1); }, "aria-label": t('users.previous'), children: _jsx(ChevronLeft, { size: 16 }) }), pageNumbers.map(function (number) { return (_jsx("button", { type: "button", className: number === currentPage ? 'is-current' : '', onClick: function () { return setPage(number); }, children: number }, number)); }), _jsx("button", { type: "button", disabled: currentPage >= pageCount, onClick: function () { return setPage(currentPage + 1); }, "aria-label": t('users.next'), children: _jsx(ChevronRight, { size: 16 }) })] })] })] }));
};
export default localeTranslator(Users, 'settings');
